import React from 'react';
import cx from 'classnames';
import { EventEmitter } from 'events';

import ModalBoxConfirmation from './ModalBoxConfirmation/ModalBoxConfirmation';
import { ModalBoxesBody, ModalBoxesFooter, ModalBoxesHeader } from './services';

class ModalBoxes extends EventEmitter {
  constructor() {
    super();
    this.modalBoxes = [];
  }

  create(modalBox) {
    const id = crypto.randomUUID();
    const defaultModalBox = {
      id,
      close: () => {
        this.close(id);
      }
    };
    const modalBoxObject = Object.assign(defaultModalBox, modalBox);
    this.modalBoxes.push(modalBoxObject);
    this.emitChange();
    return modalBoxObject;
  }

  open({ component, onClose, className, size, title, ...rest }) {
    const _size = size || component.type.size;
    return this.create({
      component,
      onCloseCallback: onClose,
      className: cx({ [`eds-modal-box-size-${_size}`]: _size }, component.type.className, className),
      title,
      ...rest
    });
  }

  confirm({ content, className, title = 'Confirmation', cancelButton, confirmButton, size } = {}) {
    return new Promise((resolve, reject) => {
      const confirmationModalInstance = this.open({
        component: (
          <ModalBoxConfirmation
            confirm={() => {
              resolve();
              confirmationModalInstance.close();
            }}
            cancelButton={cancelButton}
            confirmButton={confirmButton}
          >
            {content}
          </ModalBoxConfirmation>
        ),
        title,
        size,
        onClose() {
          reject();
        },
        className: cx('eds-modal-box-confirm', className)
      });
    });
  }

  close(id) {
    this.modalBoxes = this.modalBoxes.filter(n => id !== n.id);
    this.emitChange();
  }

  closeAll() {
    this.modalBoxes = [];
    this.emitChange();
  }

  emitChange() {
    this.emit('change', [...this.modalBoxes]);
  }

  addChangeListener(callback) {
    this.addListener('change', callback);
  }

  removeChangeListener(callback) {
    this.removeListener('change', callback);
  }
}

ModalBoxes.prototype.Header = ModalBoxesHeader;

ModalBoxes.prototype.Body = ModalBoxesBody;

ModalBoxes.prototype.Footer = ModalBoxesFooter;

export { useModalBoxes } from './services';

export default new ModalBoxes();
